
import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
import * as Icon from "react-feather"
import {
  showTotal,
  onShowSizeChange,
  itemRender,
} from "../_components/paginationfunction";
//import Data from "../assets/jsons/vendors";
import api from "../api/api"
import { useAuth } from "../context/AuthContext";
import OnHoldMobile from "./OnHoldMobile";
import ConfirmModal from "./ConfirmModal";
import { title } from "process";
import { render } from "@fullcalendar/core/preact.js";

const OnHold = () => {

  const {user} = useAuth()


  const [menu, setMenu] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [isAccepted, setIsAccepted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);


  const fetchData = async () => {
    //{loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }

    setLoadingForm(true)
    setError(null)


    try {

      if(!user.token) return
      // const response = await api.get("/agency-booking-interview");

      // console.log("User Data:", response.data);
      // console.log("Response Code:", response.status);

      // // Handle success based on status code
      // if (response.status === 200) {
      //   console.log("Form submitted successfully!");
      //   console.log(response.data)
      //   if (Array.isArray(response.data.data)) {

      //     // if(response.data.length==0)
      //     // response.data.forEach(item => console.log(item));
      //     console.log(JSON.stringify(response.data.data))

      //     //the prop children is causing error on table
      //     const updatedData = response.data.data.map(({ children, ...rest }) => ({
      //       enfants: children, // Rename 'children' to 'enfants'
      //       ...rest,
      //     }));

      //     setData(updatedData)
      //   } else {
      //     console.error("Data is not an array:", response.data);
      //     setError(response.status)
      //   }

      // } 

    } catch (error) {
      console.error("API Error:", error);

      if (error.response) {
        // The request was made and the server responded with a status code
        console.log("Error Status:", error.response.status);
        const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
      
        setError(responseCode)
        setError(error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("No response received:", error.request);
        setError("No response from server");
      } else {
        // Something happened in setting up the request
        console.log("Error setting up request:", error.message);
        setError("Request setup error");
      }
      

    } finally {


      setLoadingForm(false);
    }
  }

  const onSubmit = async() => {
    setLoadingForm(true);
    setSuccessMessage(null);
    setError(null);

    try {
        const response = await api.post('/booking/pending/', {
          id: selectedData
        });

      if (response.status === 200) {
        setSuccessMessage('Accepting vendor success');
        fetchData()
      } else {
        setError(response.data?.message || "Failed to accepting vendor");
      }
      
    }catch(error){
      setError(error.response?.data?.message || "Error saving data");
      console.error("Submit Error: ", error);
    } finally {
      setLoadingForm(false);
    }
  }

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    fetchData()
  }, [])


  const handleAccept = (record) => {
    setSelectedData(record);
    setIsAccepted(true);
  }

  const handleReject = (record) => {
    setSelectedData(record);
    setIsAccepted(false);
  }




  const columns = [
    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => (

        <div className="d-flex align-items-center">

          {user.type == "supplier" && !record.used && (
            <>
               <button
                  type="button"
                  className="btn btn-greys"
                  data-bs-toggle="modal"
                  data-bs-target="#confirmModal"
                  onClick={() => { setSelectedData(record); setIsAccepted(true) }}
                >
                  <Icon.CheckCircle /> Accept
                </button>
                <button 
                  type="button"
                  className="btn btn-greys ms-2"
                  data-bs-toggle="modal"
                  data-bs-target="#confirmModal"
                  onClick={() => { setSelectedData(record); setIsAccepted(false) }}
                >
                 <Icon.XCircle /> Reject
                </button>
            </>
          )
        }
        </div>

      ),
      //sorter: (a, b) => a.Action.length - b.Action.length,
    },
    {
      title: "Status",
      render: (_, record) => (
        <div>
          {
            record.used 
              ? (record.is_accepted 
                  ? <span className="btn btn-sm" style={{ backgroundColor: "lightgreen", width: 100 }}>Accepted</span> 
                  : <span className="btn btn-sm" style={{ backgroundColor: "lightsalmon", width: 100 }}>Rejected</span>)
              : <span className="btn btn-sm" style={{ backgroundColor: "lightgrey", width: 100 }}>Pending</span>
          }
        </div>
      )
    },
    {
      title: "Biodata Name",
      dataIndex: "biodata_supplier_name",
      sorter: (a, b) => (a.biodata_supplier_name || '').localeCompare(b.biodata_supplier_name || ''),
    },
    {
      title: "Vendor Name",
      dataIndex: "supplier_name",
      sorter: (a, b) => (a.supplier_name || '').localeCompare(b.supplier_name || ''),
    },
    {
      title: "Agency Name",
      dataIndex: "agency_name",
      sorter: (a, b) => (a.agency_name || '').localeCompare(b.agency_name || ''),
    },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     render: (value) => (
  //         <div>
  //             {value ?  <span className="badge badge-pill bg-success-light">Accepted</span> :
             
  //                 <span className="badge badge-pill bg-info">Pending</span>}
             
  //         </div>
  //     ),
  //     sorter: (a, b) => a.Status.length - b.Status.length,
  // },
    // {
    //   title: "Schedule",
    //   dataIndex: "schedule",
    //   sorter: (a, b) => a.created_at.length - b.created_at.length,
    // },
    {
      title: "Agency Note",
      dataIndex: "agency_note",
      sorter: (a, b) => (a.agency_note || '').localeCompare(b.agency_note || ''),
    },
    {
      title: "Supplier Note",
      dataIndex: "supplier_note",
      sorter: (a, b) => (a.supplier_note || '').localeCompare(b.supplier_note || ''),
    }

  ];


  const isMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
      const handleResize = () => {
          setScreenWidth(window.innerWidth);
      };

      // Add event listener for resizing
      window.addEventListener("resize", handleResize);

      // Cleanup event listener on component unmount
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  console.log(data[0]);

  const itemsPerPage = 5; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get current page data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);



  return (


    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        {(loadingForm || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <>

              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header ">
                    <h5>On Hold</h5>
                  </div>
                </div>
                
                {successMessage && (
                  <div className="alert alert-success">{successMessage}</div>
                )}
               
            {/* /Search Filter */}
                <div className="row">
                  <div className="col-sm-12">
                    {isMobileDevice() || screenWidth <= 576 ? (
                      <>
                        <OnHoldMobile data={data} screenWidth={screenWidth} onAccept={handleAccept} onReject={handleReject}/>
                      </>
                    ) : (
                      <div className=" card-table">
                        <div className="card-body vendors">
                          <div className="table-responsive table-hover table-striped">
                            <Table
                              pagination={{
                                total: data.length,
                                showTotal: (total, range) =>
                                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                // showSizeChanger: true,
                                onShowSizeChange: onShowSizeChange,
                                itemRender: itemRender,
                              }}
                              columns={columns}
                              dataSource={data}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            
          </>
        )}
      </div>

      <ConfirmModal biodata={selectedData} isAccepted={isAccepted} fetchData={fetchData} />
      </div>
  );
};

export default OnHold;
